// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes spin {
  50% {
    transform: rotate(360deg);
  }
}
@keyframes spin-reverse {
  50% {
    transform: rotate(-360deg);
  }
}
.load {
  height: 100%;
  position: relative;
  margin: auto;
  width: 100%;
  z-index: 99;
}
.load .text {
  text-align: center;
  color: var(--color-maersk-blue);
  font-size: var(--font-size-xl);
  margin-top: -5rem;
}
.load .blur-circle {
  width: 11rem;
  height: 11rem;
  background: transparent;
  box-shadow: 0px 0px 0px 1000px rgba(255, 255, 255, 0.67), 0px 0px 19px 0px rgba(0, 0, 0, 0.16) inset;
  border-radius: 100%;
  z-index: -1;
  position: relative;
  left: 0;
  right: 0;
  top: 20px;
  bottom: 0;
  margin: auto;
}
.load .load_gears {
  z-index: -2;
  width: 150px;
  height: 150px;
  top: -120px !important;
  position: relative;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.load .gear {
  position: absolute;
  width: 80px;
  height: 80px;
  margin: auto;
  background: #198;
  border-radius: 50%;
  animation-name: spin;
  animation-duration: 6s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  top: -5px;
  left: 0;
  right: 0;
}
.load .gear .center {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 50%;
}
.load .bar {
  position: absolute;
  top: -10px;
  left: 28px;
  z-index: 1;
  width: 22px;
  height: 100px;
  background: #198;
}
.load .bar:nth-child(2) {
  transform: rotate(45deg);
}
.load .bar:nth-child(3) {
  transform: rotate(90deg);
}
.load .bar:nth-child(4) {
  transform: rotate(135deg);
}
.load .gear-two {
  left: -90px;
  top: 68px;
  width: 55px;
  height: 55px;
  background: #f58bb6;
  animation-name: spin-reverse;
}
.load .gear-two .bar {
  background: #f58bb6;
  width: 14px;
  height: 70px;
  left: 20px;
  top: -8px;
}
.load .gear-two .center {
  width: 28px;
  height: 28px;
  left: 13px;
  top: 13px;
}
.load .gear-three {
  left: 90px;
  top: 68px;
  width: 55px;
  height: 55px;
  background: #576e81;
  animation-name: spin-reverse;
}
.load .gear-three .bar {
  background: #576e81;
  width: 14px;
  height: 70px;
  left: 20px;
  top: -8px;
}
.load .gear-three .center {
  width: 28px;
  height: 28px;
  left: 13px;
  top: 13px;
}`, "",{"version":3,"sources":["webpack://./src/Components/GearLoader/Loader.scss"],"names":[],"mappings":"AAMA;EACE;IAEE,yBAAA;EACF;AACF;AAOA;EACE;IAEE,0BAAA;EACF;AACF;AACA;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;AACF;AAAE;EACE,kBAAA;EACA,+BAAA;EACA,8BAAA;EACA,iBAAA;AAEJ;AAAE;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,oGAAA;EAEA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;AACJ;AACE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AACJ;AACE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,mCAAA;EACA,iCAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AACJ;AAAI;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAEN;AACE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AACJ;AAAI;EACE,wBAAA;AAEN;AAAI;EACE,wBAAA;AAEN;AAAI;EACE,yBAAA;AAEN;AACE;EACE,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;AACJ;AAAI;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;AAEN;AAAI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;AAEN;AACE;EACE,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;AACJ;AAAI;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;AAEN;AAAI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;AAEN","sourcesContent":["@-webkit-keyframes spin {\n  50% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  50% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes spin-reverse {\n  50% {\n    -webkit-transform: rotate(-360deg);\n    transform: rotate(-360deg);\n  }\n}\n@keyframes spin-reverse {\n  50% {\n    -webkit-transform: rotate(-360deg);\n    transform: rotate(-360deg);\n  }\n}\n.load {\n  height: 100%;\n  position: relative;\n  margin: auto;\n  width: 100%;\n  z-index: 99;\n  .text {\n    text-align: center;\n    color: var(--color-maersk-blue);\n    font-size: var(--font-size-xl);\n    margin-top: -5rem;\n  }\n  .blur-circle {\n    width: 11rem;\n    height: 11rem;\n    background: transparent;\n    box-shadow: 0px 0px 0px 1000px rgba(255, 255, 255, 0.67),\n      0px 0px 19px 0px rgba(0, 0, 0, 0.16) inset;\n    border-radius: 100%;\n    z-index: -1;\n    position: relative;\n    left: 0;\n    right: 0;\n    top: 20px;\n    bottom: 0;\n    margin: auto;\n  }\n  .load_gears {\n    z-index: -2;\n    width: 150px;\n    height: 150px;\n    top: -120px !important;\n    position: relative;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n  }\n  .gear {\n    position: absolute;\n    width: 80px;\n    height: 80px;\n    margin: auto;\n    background: #198;\n    border-radius: 50%;\n    animation-name: spin;\n    animation-duration: 6s;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n    top: -5px;\n    left: 0;\n    right: 0;\n    .center {\n      position: absolute;\n      top: 20px;\n      left: 20px;\n      z-index: 10;\n      width: 40px;\n      height: 40px;\n      background: #fff;\n      border-radius: 50%;\n    }\n  }\n  .bar {\n    position: absolute;\n    top: -10px;\n    left: 28px;\n    z-index: 1;\n    width: 22px;\n    height: 100px;\n    background: #198;\n    &:nth-child(2) {\n      transform: rotate(45deg);\n    }\n    &:nth-child(3) {\n      transform: rotate(90deg);\n    }\n    &:nth-child(4) {\n      transform: rotate(135deg);\n    }\n  }\n  .gear-two {\n    left: -90px;\n    top: 68px;\n    width: 55px;\n    height: 55px;\n    background: #f58bb6;\n    animation-name: spin-reverse;\n    .bar {\n      background: #f58bb6;\n      width: 14px;\n      height: 70px;\n      left: 20px;\n      top: -8px;\n    }\n    .center {\n      width: 28px;\n      height: 28px;\n      left: 13px;\n      top: 13px;\n    }\n  }\n  .gear-three {\n    left: 90px;\n    top: 68px;\n    width: 55px;\n    height: 55px;\n    background: #576e81;\n    animation-name: spin-reverse;\n    .bar {\n      background: #576e81;\n      width: 14px;\n      height: 70px;\n      left: 20px;\n      top: -8px;\n    }\n    .center {\n      width: 28px;\n      height: 28px;\n      left: 13px;\n      top: 13px;\n    }\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
